import React from "react";
const LocationIcon = ({ size = 24, color = "#000" }) => (
  <svg
    width={size}
    height={size}
    color="#333"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.685 13.2H1.2a1.2 1.2 0 110-2.4h2.485A8.405 8.405 0 0110.8 3.685V1.2a1.2 1.2 0 112.4 0v2.485a8.405 8.405 0 017.115 7.115H22.8a1.2 1.2 0 110 2.4h-2.485a8.405 8.405 0 01-7.115 7.115V22.8a1.2 1.2 0 11-2.4 0v-2.485A8.405 8.405 0 013.685 13.2zM12 18a6 6 0 100-12 6 6 0 000 12zm0-3.6a2.4 2.4 0 110-4.8 2.4 2.4 0 010 4.8z"
      fill="currentColor"
      fillRule="nonzero"
    ></path>
  </svg>
);
export default LocationIcon;
